import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishCreateImagePage } from '../../../dish/dish-create/dish-create-image/dish-create-image';
import { ProductCreateWfoodcostImagePage } from '../../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-image/product-create-wfoodcost-image';
import { ProductCreateFoodcostImagePage } from '../../../products/product-create/product-create-foodcost/product-create-foodcost-image/product-create-foodcost-image';

@Component({
    selector: 'page-article-view-photo',
    templateUrl: 'article-view-photo.html',
})

export class ArticleViewPhotoPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {

    }

    edit() {
        if (this.article.type === 'dish') {
            if (this.globals.checkLimitsByLicense('dishes', 'image')) {
                this.navCtrl.push(DishCreateImagePage, {
                    update: true,
                    dish_uid: this.article.UID,
                    image: this.article.image,
                    image_url: this.article.image_url,
                    dish_name: this.globals.nameLangSelectDish(this.article),
                    dish: this.article
                });
            } else {
                this.navCtrl.push(AddonsTriggerVersionProPage);
            }
        } else {
            if (this.globals.checkLimitsByLicense("stock", "image")) {
                if (this.article.sub_recipe) {
                    this.navCtrl.push(ProductCreateFoodcostImagePage, {
                        update_state: true,
                        product_uid: this.article.UID,
                        image_url: this.article.image_url,
                        image: this.article.image,
                        product_name: this.globals.nameLangSelectProduct(this.article),
                        product: this.article
                    });
                } else {
                    this.navCtrl.push(ProductCreateWfoodcostImagePage, {
                        update_state: true,
                        product_uid: this.article.UID,
                        image_url: this.article.image_url,
                        image: this.article.image,
                        product_name: this.globals.nameLangSelectProduct(this.article),
                        product: this.article
                    });
                }
            } else {
                this.navCtrl.push(AddonsTriggerVersionProPage);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-photo/article-view-photo.ts